import classnames from 'classnames';

import { Chip } from '../../Chip';

import styles from './ExclusiveSelectionGroup.module.scss';
import { ExclusiveSelectionGroupProps } from './ExclusiveSelectionGroup.types';

/**
 * @deprecated use `ExclusiveChipGroup` instead
 * @example import { ExclusiveChipGroup, ChipGroupItem } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <ExclusiveChipGroup value={value} onValueChange={setValue}>
 *            <ChipGroupItem value="0" disabled>item</ChipGroupItem>
 *            <ChipGroupItem value="1">item</ChipGroupItem>
 *          </ExclusiveChipGroup>
 */
export const ExclusiveSelectionGroup = <T,>({
  values,
  className,
  buttonClassName,
  selectedClassName,
  selected,
  setSelected,
  canBeReset,
  getKey,
  getStringValue,
  disabled,
  dense,
  large,
  verticalDisplay,
  leftIcons,
}: ExclusiveSelectionGroupProps<T>) => {
  return (
    <div
      className={classnames(styles.container, className, {
        [styles.verticalContainer]: verticalDisplay,
      })}
    >
      {values.map((value, index) => {
        const id = getKey(value);
        const label = getStringValue(value);

        const isSelected = selected && id === getKey(selected);

        return (
          <Chip
            key={id}
            selected={isSelected}
            disabled={disabled}
            className={classnames(buttonClassName, isSelected && selectedClassName, {
              [styles.dense]: dense,
              [styles.large]: large,
            })}
            onClick={() => {
              if (!isSelected) setSelected(value);
              else if (canBeReset) setSelected(undefined);
            }}
          >
            {leftIcons ? leftIcons[index] : undefined}
            {label}
          </Chip>
        );
      })}
    </div>
  );
};
